import { Button } from "@/components/ui";
import { useGoogleLogin } from "@react-oauth/google";

interface GoogleButtonProps {
  onSuccess: (token: string) => void;
  onError: (error?: string) => void;
}

export const GoogleButton = ({ onSuccess, onError }: GoogleButtonProps) => {
  const login = useGoogleLogin({
    onSuccess: (tokenResponse) => onSuccess(tokenResponse.access_token),
    onError: (error) => onError(error.error),
  });
  return (
    <div className="w-full flex justify-center">
      <Button type="button" onClick={() => login()}>
        Login with Google
      </Button>
    </div>
  );
};
